import isFuture from 'date-fns/is_future';
import isPast from 'date-fns/is_past';

const isValidPurchaseDates = (purchase_start_date, purchase_end_date) => {
  const startDate = purchase_start_date?.iso_value;
  const endDate = purchase_end_date?.iso_value;

  return (!startDate || isPast(startDate)) && (!endDate || isFuture(endDate));
};

export default isValidPurchaseDates;
